<template>
  <el-card class="box-card">
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">User Activity</span>
      <span :class="{'ring-card__header-buttons': true, 'disable-html': loading }">
        <RefreshButton @click.native="getUserActivity()" />
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <div
          class="flex justify-between items-center"
          style="margin: 7px 0 20px 0">
        <div
            data-info="filters"
            class="flex items-center justify-between filter-fields">
          <!--  DATE RANGE -->

          <el-date-picker
              v-model="activityRange"
              type="datetimerange"
              :size="btnSize"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              style="min-width: 400px"
              format="MM/dd/yyyy HH:mm:ss"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              align="right" />
          <!-- CONTEXT -->

          <el-select
              v-model="filters.context"
              :size="btnSize"
              placeholder="Context"
              style="max-width: 100px">
            <el-option
                v-for="item in context"
                :key="item.value"
                :label="item.text"
                :value="item.value" />
          </el-select>
          <!-- ACTIVITY TYPE -->

          <el-select
              v-model="filters.event_type"
              :size="btnSize"
              filterable
              clearable
              auto-complete="description"
              placeholder="Type">
            <el-option
                v-for="item in eventTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value" />
          </el-select>
          <el-button
              type="primary"
              :size="btnSize"
              @click="getUserActivity()">
            Apply filters
          </el-button>
          <el-button
              :size="btnSize"
              @click="resetFilters()">
            Reset
          </el-button>
        </div>
      </div>
      <el-table
          :data="userActivities"
          class="user-activity-table"
          style="width: 100%">
        <el-table-column label="Date">
          <template slot-scope="scope">
            <time-zone-formatter :current-time=" scope.row.created_at" />
          </template>
        </el-table-column>
        <el-table-column
            label="Context">
          <template slot-scope="scope">
            <span>
              {{ scope.row.context }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="Activity">
          <template slot-scope="scope">
            {{ scope.row.event }}
          </template>
        </el-table-column>
        <el-table-column label="Agent">
          <template slot-scope="scope">
            <span>
              {{ scope.row.admin_user }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Device Type">
          <template slot-scope="scope">
            <span>
              {{ scope.row.device_type }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Device Name">
          <template slot-scope="scope">
            <router-link :to="{ name: 'Device', params: { doorbot_id: scope.row.doorbot_id} }">
              {{ scope.row.device_name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
            label=""
            :width="50">
          <template slot-scope="scope">
            <MetadataPopover
                v-if="scope.row.ui_metadata"
                :metadata.sync="scope.row.ui_metadata" />
          </template>
        </el-table-column>
      </el-table>
      <div class="user-activity-table__footer-pagination">
        <el-alert
            v-if="error.value"
            style="margin-bottom: 14px"
            :title="error.message"
            type="info"
            center
            show-icon />
        <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="total"
            @current-change="onPageChange" />
      </div>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
import MetadataModal from "@/containers/Customer/History/MetadataModal";
import MetadataPopover from "@/containers/Customer/History/MetadataPopover";
import RefreshButton from "@/containers/Customer/RefreshButton";
const { mapActions, mapGetters } = h("db/account");
const { mapActions: devicesActions, mapGetters: devicesGetters } =
  h("db/devices");
const { mapGetters: sharedGetters } = h("shared");
import { forEach } from "lodash";
import axios from "axios";

export default {
  name: "UserActivity",
  components: {
    MetadataModal,
    MetadataPopover,
    RefreshButton,
  },
  data() {
    return {
      btnSize: "small",
      loading: false,
      error: {
        value: false,
        message: "Failed to load User Activity",
      },
      currentPage: 1,
      page: 1,
      pageSize: 10,
      total: 0,
      data: { activities: [], meta: { total: 0 } },
      userActivities: [],
      activityRange: [],
      filters: {
        event_type: "",
        context: "ND",
        date_from: "",
        date_to: "",
        page: 1,
      },
      eventTypes: [],
      context: [
        { value: "ND", text: "ND" },
        { value: "AP", text: "AP" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["customerId", "customer"]),
    ...devicesGetters(["simpleDevices"]),
    ...sharedGetters(["products"]),
  },
  created() {
    this.getActivityNames();
    if (this.simpleDevices == null || this.simpleDevices.length == 0) {
      this.fetchSimpleDeviceList({ customer_id: this.customerId }).finally(() =>
        this.getUserActivity()
      );
    } else {
      this.getUserActivity();
    }
  },
  methods: {
    ...mapActions(["fetchUserLogs"]),
    ...devicesActions(["fetchSimpleDeviceList"]),
    filterActivityType(value, row) {
      return get(row, "event_type", null) === value;
    },
    onPageChange() {
      this.getUserActivity(this.currentPage, this.pageSize);
    },
    parseUIMetadata(metadata) {
      if (!metadata) return null;
      try {
        return JSON.stringify(JSON.parse(metadata).ui);
      } catch (e) {
        return null;
      }
    },
    getUserActivity(page = 1) {
      this.loading = true;
      let options = this.parseFilters(page);
      this.fetchUserLogs({ customerId: this.customerId, options })
        .then((response) => {
          forEach(response.activities || [], (activity) => {
            let device =
              (this.simpleDevices || []).find(
                (device) => device.doorbot_id === activity.doorbot_id
              ) || {};

            let product =
              this.products.find((product) => product.kind === device.type) ||
              {};

            activity["device_type"] =
              product.marketing_name || device.type || "";
            activity["device_name"] = device.name || "";

            activity["ui_metadata"] = this.parseUIMetadata(
              activity["metadata"]
            );
          });

          this.userActivities = response.activities;
          this.total = response.total;
        })
        .catch((error) => {
          console.log("Error", error);
          this.$notify({
            title: "User Activity",
            message: h(
              "i",
              { class: { "update-setting_error_msg": true } },
              "No User Activity found"
            ),
            duration: 0,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getActivityNames() {
      axios
        .get("/v2/admin_logs/activity_names.json")
        .then((response) => {
          const entries = response.data.sort();
          this.eventTypes = entries.map((entry) => {
            return { value: entry, text: entry };
          });
          this.eventTypes.unshift({ value: "", text: "All Activities" });
        })
        .catch((error) => {
          console.log("Error", error);
          this.$notify({
            title: "User Activity",
            message: h(
              "i",
              { class: { "update-setting_error_msg": true } },
              "No Activity Names found"
            ),
            duration: 0,
          });
        });
    },
    resetFilters() {
      this.activityRange = [];
      this.filters = {
        event_type: "",
        context: "ND",
        date_from: "",
        date_to: "",
        page: 1,
      };
      this.getUserActivity();
    },
    parseFilters(page) {
      let options = { ...this.filters };
      options.page = page;
      options.pageSize = this.pageSize;
      if (this.activityRange && this.activityRange.length > 1) {
        let [from, to] = this.activityRange;
        if (from) options.date_from = this.$moment(from).utc();
        if (to) options.date_to = this.$moment(to).utc();
      }
      return options;
    },
  },
};
</script>

<style lang="scss">
.user-activity-table__footer-pagination {
  margin: 40px 0 20px;
}
</style>
